import Api from '@/services/Api'

export default {
  assignLinkAndEmail (email) {
    return Api().post('user/register/invite', email)
  },
  confirmLink (randomstring) {
    return Api().get('user/register/' + randomstring)
  }
}



// WEBPACK FOOTER //
// ./src/services/RegistrationLinkService.js